// @flow
import PaymentMethod from './payment-method'
import OrderItemPaymentConfiguration from './order-item-payment-configuration'

export type PaymentMethodsOrder = {
  paymentMethods: PaymentMethod[],
  orderItemPaymentConfigurations: { [string]: OrderItemPaymentConfiguration }
}

const buildPaymentMethodsOrder = function () : PaymentMethodsOrder {
  return {
    paymentMethods: [],
    orderItemPaymentConfigurations: {}
  }
}

export {
  buildPaymentMethodsOrder
}



// WEBPACK FOOTER //
// ./src/types/payment-methods-order.js